import { createElement } from "react";
import React from "react";
import { useCtx } from "./Context.jsx";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "./fable_modules/fable-library-js.4.29.0/Util.js";
import { Spinner, Button, tokens, Caption1, Title3 } from "@fluentui/react-components";
import { ofArray } from "./fable_modules/fable-library-js.4.29.0/List.js";
import { ArrowDownloadRegular, DocumentArrowDownRegular } from "@fluentui/react-icons";
import { empty, singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.29.0/Seq.js";
import { reactApi as reactApi_1 } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { tap } from "./fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { errorToast } from "./Toasts.jsx";
import { ByteArrayExtensions_SaveFileAs_5EF83E14 } from "./fable_modules/Fable.Remoting.Client.8.0.0/Extensions.fs.js";
import { now, toShortDateString } from "./fable_modules/fable-library-js.4.29.0/Date.js";
import { startAsPromise } from "./fable_modules/fable-library-js.4.29.0/Async.js";
import { toastServerError, Report } from "./ApiClient.jsx";

export function View() {
    let elems_5, elems_4, elems, el, el_2, elems_3, elems_2, el_4, el_6, value_51, el_12;
    const setCtx = useCtx()[1];
    const patternInput_1 = reactApi.useState(false);
    const setIsDownloading = patternInput_1[1];
    const isDownloading = patternInput_1[0];
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        height: 15 + "vh",
        gap: 20 + "px ",
    }], (elems_5 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
        gap: 25 + "px ",
        height: 100 + "%",
    }], (elems_4 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
    }], (elems = [(el = Title3, createElement(el, {
        children: "Rapporter",
    })), (el_2 = Caption1, createElement(el_2, {
        style: {
            color: tokens.colorNeutralForeground3,
        },
        children: "Last ned rapporter for systemet",
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 25 + "px ",
    }], (elems_3 = [createElement("div", createObj(ofArray([["style", {
        height: 100 + "%",
        maxWidth: 400,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 25 + "px ",
    }], (elems_2 = [(el_4 = DocumentArrowDownRegular, createElement(el_4, {
        fontSize: 120,
        primaryFill: tokens.colorBrandBackgroundInvertedSelected,
    })), (el_6 = Caption1, createElement(el_6, createObj(ofArray([["align", "center"], (value_51 = "Last ned rapport over hver enkelt bruker sin progresjon for hvert enkelt læringsløp samt generell informasjon om den enkelte bruker", ["children", value_51])])))), (el_12 = Button, createElement(el_12, createObj(toList(delay(() => append(singleton(["children", "Last ned"]), delay(() => append(singleton(["appearance", "primary"]), delay(() => append(singleton(["disabled", isDownloading]), delay(() => {
        let el_8;
        return append(singleton(["icon", (el_8 = ArrowDownloadRegular, createElement(el_8, {
            fontSize: 24,
        }))]), delay(() => {
            let elems_1, el_10;
            return append(isDownloading ? singleton((elems_1 = [(el_10 = Spinner, createElement(el_10, {
                size: "tiny",
            }))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])) : empty(), delay(() => singleton(["onClick", (_arg) => {
                setIsDownloading(true);
                const pr = tap((res) => {
                    if (res.tag === 1) {
                        setIsDownloading(false);
                        errorToast(setCtx, "OverallReportError", "Noe gikk galt", "Kunne ikke lage datasett", undefined);
                    }
                    else {
                        setIsDownloading(false);
                        ByteArrayExtensions_SaveFileAs_5EF83E14(res.fields[0], `${toShortDateString(now())}.xlsx`);
                    }
                }, startAsPromise(Report.Overall()));
                void (pr.catch((ex) => {
                    toastServerError(setCtx, ex);
                }));
            }])));
        }));
    })))))))))))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

//# sourceMappingURL=Report.jsx.map
